const MEDIA_BASE_URL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8080/api/v1').replace(/\/api\/v1\/?$/, '');

// Turns a stored media path (e.g. /media/attachments/x.jpg) into a full URL.
export const mediaUrl = (path: string) => `${MEDIA_BASE_URL}${path}`;
